import type { SectionPermissions } from '../../Shared/PermissionAccessGuard/hooks/useSectionPermissions'
import { COP_SITE_DETAILS_BUTTON_TYPE } from '../constants/copSiteDetails.constants'
import { ButtonConfig } from '../copSiteDetails'

export type SitePermissionFlags = {
    canExportSiteDetails: boolean
    canReportDataIssue: boolean
    canViewAssetsTree: boolean
    hasAssets: boolean
    canEditContact: boolean
}

// fail open while permissions are still resolving — only gate once denial is confirmed
export function resolveSitePermissionFlags(
    permissions: SectionPermissions,
    permissionsLoading: boolean,
    assetsCount: number | null | undefined,
): SitePermissionFlags {
    return {
        canExportSiteDetails: permissionsLoading || permissions.canViewSitesExportDetails,
        canReportDataIssue: permissionsLoading || permissions.canViewSitesReportDataIssue,
        canViewAssetsTree: permissionsLoading || permissions.canViewSitesViewAssetsTree,
        hasAssets: (assetsCount ?? 0) > 0,
        canEditContact: permissionsLoading || permissions.canViewSitesEditContact,
    }
}

export function isPermittedButton(btn: ButtonConfig, canViewAssetsTree: boolean, canReportDataIssue: boolean): boolean {
    const icon = (btn.buttonIcon || '').toLowerCase()
    if (icon.includes('vector')) return canViewAssetsTree
    if (icon.includes('alert')) return canReportDataIssue
    return true
}

export function buildActiveButtons(
    permittedButtons: ButtonConfig[],
    exportLabel: string,
    canExportSiteDetails: boolean,
): ButtonConfig[] {
    const ctaBtns = permittedButtons.filter(b => b.buttonType === COP_SITE_DETAILS_BUTTON_TYPE.CTA)
    if (!canExportSiteDetails) return ctaBtns
    const dropdownBtns = permittedButtons.filter(b => b.buttonType === COP_SITE_DETAILS_BUTTON_TYPE.DROPDOWN)
    const fallbackDropdown = [{ buttonType: COP_SITE_DETAILS_BUTTON_TYPE.DROPDOWN, buttonLabel: exportLabel, buttonIcon: '', buttonUrl: '' }] as const
    return [...ctaBtns, ...(dropdownBtns.length > 0 ? dropdownBtns : fallbackDropdown)]
}
